import { ITheme, IStyle, mergeStyleSets, getTheme, MessageBarType } from '@fluentui/react';
import React from 'react';
import { ICustomerEnrollmentFormModel } from '../../form-services/customer-enrollment-iface';
import * as formService from '../../form-services/customer-enrollment';
import { BwjGrid } from '../../../framework/components/bwj-layout';
import { RowCol } from '../../../framework/components/bwj-layout/rowcol';
import { Spacing } from '../../../framework/components/bwj-layout/styles';
import { BwjTextField } from '../../../framework/components/bwj-text-field';
import { BwjText, BwjTextSize } from '../../../framework/components/bwj-text';
import { BwjButton, BwjButtonType } from '../../../framework/components/bwj-button';
import { BwjNote } from '../../../framework/components/bwj-note';

interface IMeasurementRequestFormProps {
  formModel: ICustomerEnrollmentFormModel;
  onRequestSubmitted: () => void;
  onDismiss: () => void;
}

const getStyleClasses = (theme: ITheme) => {
  const buttonContainer: IStyle = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: '1.5rem',
    margin: 0,
    padding: 0,
  };

  return mergeStyleSets({
    buttonContainer,
  });
}

export const MeasurementRequestForm: React.FunctionComponent<IMeasurementRequestFormProps> = (props) => {
  const theme = getTheme();
  const cs = getStyleClasses(theme);
  const { formModel } = props;

  const onRequestSubmitted = () => {
    formService.validateAndUpdateModel()
    .then(result => {
      result.isValid && props.onRequestSubmitted();
    });
  }

  return (
    <BwjGrid>
      <RowCol bottomSpacing={Spacing.Large}>
        <h2>Request A Free Measurement</h2>
        <BwjNote
          type={MessageBarType.info}
          textContent={'<strong>This is the first step to enjoying your new storm door!</strong> After we measure the entryways where you wish to install storm doors, we\'ll give you access to a private online catalog created just for you, with door options curated to fit each entryway perfectly.'}
          renderTextAsHtml={true}
        />
      </RowCol>
      <RowCol bottomSpacing={Spacing.Medium}>
        <BwjTextField
          id={formService.name.id}
          required={true}
          label={formService.name.description}
          onUpdate={formService.name.onUpdate}
          input={formModel.name}
          filter={/^.{0,60}$/}
        />
      </RowCol>
      <RowCol bottomSpacing={Spacing.Medium}>
        <BwjTextField
          id={formService.phone.id}
          required={false}
          label={formService.phone.description}
          onUpdate={formService.phone.onUpdate}
          input={formModel.phone}
          filter={/^.{0,20}$/}
        />
        <BwjText
          textSize={BwjTextSize.xSmall}
        >
          Optional, but highly recommended for best service
        </BwjText>
      </RowCol>
      <RowCol bottomSpacing={Spacing.Medium}>
        <BwjTextField
          id={formService.email.id}
          required={true}
          label={formService.email.description}
          onUpdate={formService.email.onUpdate}
          input={formModel.email}
          filter={/^.{0,200}$/}
        />
      </RowCol>
      <RowCol bottomSpacing={Spacing.Medium}>
        <BwjTextField
          id={formService.zipCode.id}
          required={true}
          label={formService.zipCode.description}
          onUpdate={formService.zipCode.onUpdate}
          input={formModel.zipCode}
          filter={/^\d{0,5}$/}
        />
      </RowCol>
      <RowCol bottomSpacing={Spacing.Medium}>
        <div className={cs.buttonContainer}>
          <BwjButton
            buttonStyle={BwjButtonType.PrimaryStandard}
            text={'Submit request'}
            onClick={onRequestSubmitted}
          />
          <BwjButton
            buttonStyle={BwjButtonType.DefaultStandard}
            text={'Cancel'}
            onClick={props.onDismiss}
          />
        </div>
      </RowCol>
      <RowCol bottomSpacing={Spacing.Medium}>
        <BwjText
          textSize={BwjTextSize.xSmall}
        >
          By submitting this request, you acknowledge that you read and accept our <a href="http://bwjstorm.com/service/terms" rel='noreferrer' target="_blank">Terms of Service</a>.
        </BwjText>
      </RowCol>
    </BwjGrid>
  );
};
